export const YEAR_OPTIONS = [2026, 2027, 2028] as const;
export const DEFAULT_YEAR = 2027;
